<template>
  <div>
    <v-app>
      <div id="chart">
        <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
      </div>

      <button @click="exportToPDF">Export to PDF</button>
      <div id="app" ref="document">
        <v-row>
          <v-col md="6">
            <div class="pa-16">
              <table class="table" cellpadding="0" cellspacing="0" width="100%">
                <thead class="center header-table">
                  <tr>
                    <th rowspan="2" class="header-table-text first">No</th>
                    <th rowspan="2" width="20%" class="header-table-text">Mata Pelajaran</th>
                    <th colspan="4" class="header-table-text last-top">Pengetahuan dan Keterampilan <v-divider class="mt-2 mb-2" /></th>
                  </tr>
                  <tr>
                    <th class="header-table-text">KKM</th>
                    <th class="header-table-text">Nilai</th>
                    <th class="header-table-text">Predikat</th>
                    <th width="35%" class="header-table-text last-bottom">Deskripsi</th>
                  </tr>
                </thead>
                <tbody v-for="(parentData, indexParent) in eraporGroups" :key="indexParent">
                  <tr class="header-group pa-16">
                    <td class="header-group-text" colspan="6">
                      <strong class="ml-8">{{ parentData.name }}</strong>
                    </td>
                  </tr>
                  <tr v-for="(childData, indexChild) in parentData.courses" :key="indexChild">
                    <td style="text-align: center;">{{ indexChild + 1 }}</td>
                    <td style="text-align: center;">{{ childData.courseName }}</td>
                    <td style="text-align: center;">{{ childData.minimumCriteria }}</td>
                    <td style="text-align: center;">{{ childData.value }}</td>
                    <td style="text-align: center;">{{ childData.predicate }}</td>
                    <td style="text-align: center;">{{ childData.description }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-col>
          <v-col md="6">
            <div class="pa-16">
              <table class="table" cellpadding="0" cellspacing="0" width="100%">
                <thead class="center header-table">
                  <tr>
                    <th rowspan="2" class="header-table-text first">No</th>
                    <th rowspan="2" width="20%" class="header-table-text">Mata Pelajaran</th>
                    <th colspan="4" class="header-table-text last-top">Pengetahuan dan Keterampilan <v-divider class="mt-2 mb-2" /></th>
                  </tr>
                  <tr>
                    <th class="header-table-text">KKM</th>
                    <th class="header-table-text">Nilai</th>
                    <th class="header-table-text">Predikat</th>
                    <th width="35%" class="header-table-text last-bottom">Deskripsi</th>
                  </tr>
                </thead>
                <tbody v-for="(parentData, indexParent) in eraporGroups" :key="indexParent">
                  <tr class="header-group pa-16">
                    <td class="header-group-text" colspan="6">
                      <strong class="ml-8">{{ parentData.name }}</strong>
                    </td>
                  </tr>
                  <tr v-for="(childData, indexChild) in parentData.courses" :key="indexChild">
                    <td style="text-align: center;">{{ indexChild + 1 }}</td>
                    <td style="text-align: center;">{{ childData.courseName }}</td>
                    <td style="text-align: center;">{{ childData.minimumCriteria }}</td>
                    <td style="text-align: center;">{{ childData.value }}</td>
                    <td style="text-align: center;">{{ childData.predicate }}</td>
                    <td style="text-align: center;">{{ childData.description }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-col>
        </v-row>

        <span class="break-page"></span>
        <div class="pa-16">
          <table class="table" cellpadding="0" cellspacing="0" width="100%">
            <thead class="center header-table">
              <tr>
                <th rowspan="2" class="header-table-text first">No</th>
                <th rowspan="2" width="20%" class="header-table-text">Mata Pelajaran</th>
                <th colspan="4" class="header-table-text last-top">Pengetahuan dan Keterampilan <v-divider class="mt-2 mb-2" /></th>
              </tr>
              <tr>
                <th class="header-table-text">KKM</th>
                <th class="header-table-text">Nilai</th>
                <th class="header-table-text">Predikat</th>
                <th width="35%" class="header-table-text last-bottom">Deskripsi</th>
              </tr>
            </thead>
            <tbody v-for="(parentData, indexParent) in eraporGroups" :key="indexParent">
              <tr class="header-group pa-16">
                <td class="header-group-text" colspan="6">
                  <strong class="ml-8">{{ parentData.name }}</strong>
                </td>
              </tr>
              <tr v-for="(childData, indexChild) in parentData.courses" :key="indexChild">
                <td style="text-align: center;">{{ indexChild + 1 }}</td>
                <td style="text-align: center;">{{ childData.courseName }}</td>
                <td style="text-align: center;">{{ childData.minimumCriteria }}</td>
                <td style="text-align: center;">{{ childData.value }}</td>
                <td style="text-align: center;">{{ childData.predicate }}</td>
                <td style="text-align: center;">{{ childData.description }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pa-16">
          <table class="table" cellpadding="0" cellspacing="0" width="100%">
            <thead class="center header-table">
              <tr>
                <th rowspan="2" class="header-table-text first">No</th>
                <th rowspan="2" width="20%" class="header-table-text">Mata Pelajaran</th>
                <th colspan="4" class="header-table-text last-top">Pengetahuan dan Keterampilan <v-divider class="mt-2 mb-2" /></th>
              </tr>
              <tr>
                <th class="header-table-text">KKM</th>
                <th class="header-table-text">Nilai</th>
                <th class="header-table-text">Predikat</th>
                <th width="35%" class="header-table-text last-bottom">Deskripsi</th>
              </tr>
            </thead>
            <tbody v-for="(parentData, indexParent) in eraporGroups" :key="indexParent">
              <tr class="header-group pa-16">
                <td class="header-group-text" colspan="6">
                  <strong class="ml-8">{{ parentData.name }}</strong>
                </td>
              </tr>
              <tr v-for="(childData, indexChild) in parentData.courses" :key="indexChild">
                <td style="text-align: center;">{{ indexChild + 1 }}</td>
                <td style="text-align: center;">{{ childData.courseName }}</td>
                <td style="text-align: center;">{{ childData.minimumCriteria }}</td>
                <td style="text-align: center;">{{ childData.value }}</td>
                <td style="text-align: center;">{{ childData.predicate }}</td>
                <td style="text-align: center;">{{ childData.description }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pa-16">
          <table class="table" cellpadding="0" cellspacing="0" width="100%">
            <thead class="center header-table">
              <tr>
                <th rowspan="2" class="header-table-text first">No</th>
                <th rowspan="2" width="20%" class="header-table-text">Mata Pelajaran</th>
                <th colspan="4" class="header-table-text last-top">Pengetahuan dan Keterampilan <v-divider class="mt-2 mb-2" /></th>
              </tr>
              <tr>
                <th class="header-table-text">KKM</th>
                <th class="header-table-text">Nilai</th>
                <th class="header-table-text">Predikat</th>
                <th width="35%" class="header-table-text last-bottom">Deskripsi</th>
              </tr>
            </thead>
            <tbody v-for="(parentData, indexParent) in eraporGroups" :key="indexParent">
              <tr class="header-group pa-16">
                <td class="header-group-text" colspan="6">
                  <strong class="ml-8">{{ parentData.name }}</strong>
                </td>
              </tr>
              <tr v-for="(childData, indexChild) in parentData.courses" :key="indexChild">
                <td style="text-align: center;">{{ indexChild + 1 }}</td>
                <td style="text-align: center;">{{ childData.courseName }}</td>
                <td style="text-align: center;">{{ childData.minimumCriteria }}</td>
                <td style="text-align: center;">{{ childData.value }}</td>
                <td style="text-align: center;">{{ childData.predicate }}</td>
                <td style="text-align: center;">{{ childData.description }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- <div id="app">
        <v-btn class="elevation-0" @click="download">Download</v-btn>
      </div> -->
      <!-- <v-card>
        <vue-qrcode value="https://fengyuanchen.github.io/vue-qrcode" tag="svg" :options="{ width: 148 }"></vue-qrcode>
      </v-card> -->
      <!-- <v-tabs grow v-model="active_tab">
        <v-tab v-for="tab of tabs" :key="tab.id">
          {{ tab.name }}
        </v-tab>
      </v-tabs> -->

      <!-- <div class="pa-16">
        <table class="table" cellpadding="0" cellspacing="0" width="100%">
          <thead class="center header-table">
            <tr>
              <th rowspan="2" class="header-table-text first">Course</th>
              <th v-for="(item, index) in assignmentCount" :key="index" rowspan="2" class="header-table-text">Assignment {{ index + 1 }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in datasCourse" :key="index">
              <td style="text-align: center;font-size: 12px">{{ item.courseName }}</td>
              <td v-for="(datas, index) in item.assignments" :key="index" style="text-align: center; font-size: 12px;">
                {{ datas.score }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="attendance-scroller pa-6">
        <table class="attendance-table">
          <thead>
            <tr>
              <th width="250" class="attendance-sticky">
                <div>Course</div>
              </th>
              <th width="280" v-for="(item, index) in assignmentCount" :key="index">
                <div>
                  <div class="d-flex flex-row justify-start">
                    <div class="flex-grow-1">Assignment {{ index + 1 }}</div>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in datasCourse" :key="index">
              <td class="attendance-sticky">
                <div class="d-flex align-center" style="height:40px">{{ item.courseName }}</div>
              </td>
              <td class="attendance-sticky" valign="middle" v-for="(datas, index) in item.assignments" :key="index">
                <span>
                  {{ datas.score }}
                </span>
              </td>
              <td v-for="(item, index) in assignmentCount - item.assignments.length" :key="index" width="**">-</td>
            </tr>
          </tbody>
        </table>
      </div> -->

      <!-- <froala :tag="'textarea'" v-model="model"></froala>
      <v-btn color="primary" dark @click="dialog = true">
        Open Dialog
      </v-btn>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent>
          <v-card>
            <v-row class="no-gutters elevation-4">
              <v-col cols="12" sm="3" class="flex-grow-1 flex-shrink-0" style="border-right: 1px solid #0000001f;">
                <v-responsive class="overflow-y-auto fill-height" height="500">
                  <v-list subheader>
                    <v-list-item-group v-model="activeChat">
                      <template v-for="(item, index) in messageByUser">
                        <v-list-item :key="`parent${index}`" :value="item.id">
                          <v-list-item-avatar color="grey lighten-1 white--text">
                            <v-icon>
                              mdi-account
                            </v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content @click="changeAccount(item)">
                            <v-list-item-title v-text="item.userName" />
                            <v-list-item-subtitle v-text="`${item.lastMessage.content}`" />
                          </v-list-item-content>
                          <v-list-item-icon>
                            <v-icon :color="item.active ? 'primary' : 'light-blue accent-3'">
                              mdi-chat
                            </v-icon>
                          </v-list-item-icon>
                        </v-list-item>
                        <v-divider :key="`chatDivider${index}`" class="my-0" />
                      </template>
                    </v-list-item-group>
                  </v-list>
                </v-responsive>
              </v-col>
              <v-col cols="auto" class="flex-grow-1 flex-shrink-0">
                <v-responsive v-if="activeChat" class="overflow-y-hidden fill-height" height="500">
                  <v-card flat class="d-flex flex-column fill-height">
                    <v-card-title>
                      {{ to.name }}
                      <v-btn color="green darken-1" text @click="dialog = false">
                        Agree
                      </v-btn>
                    </v-card-title>
                    <v-card-text id="container" class="flex-grow-1" style="max-height:100%; overflow-y: auto;">
                      <div v-for="(msg, i) in messageList" :key="i">
                        <div :class="{ 'd-flex flex-row-reverse': msg.isFromSelf }">
                          <template>
                            <v-chip
                              :color="msg.isFromSelf ? 'primary' : 'light-blue accent-3'"
                              dark
                              style="height:auto;white-space: normal;"
                              class="pa-4 mb-2"
                            >
                              {{ msg.content }}

                              <sub class="ml-2" style="font-size: 0.5rem;">{{ msg.updatedAt }}</sub>
                            </v-chip>
                          </template>
                        </div>
                      </div>
                    </v-card-text>
                    <v-card-text class="flex-shrink-1">
                      <v-text-field
                        v-model="messageContent.content"
                        label="Type a message"
                        type="text"
                        no-details
                        outlined
                        append-outer-icon="mdi-send"
                        @keyup.enter="incomingMessage"
                        @click:append-outer="incomingMessage"
                        hide-details
                      />
                    </v-card-text>
                  </v-card>
                </v-responsive>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
      </v-row> -->

      <!-- <v-container class="fill-height pa-0 ">
          <v-row class="no-gutters elevation-4">
            <v-col cols="12" sm="3" class="flex-grow-1 flex-shrink-0" style="border-right: 1px solid #0000001f;">
              <v-responsive class="overflow-y-auto fill-height" height="500">
                <v-list subheader>
                  <v-list-item-group v-model="activeChat">
                    <template v-for="(item, index) in parents">
                      <v-list-item :key="`parent${index}`" :value="item.id">
                        <v-list-item-avatar color="grey lighten-1 white--text">
                          <v-icon>
                            mdi-account
                          </v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title v-text="item.title" />
                          <v-list-item-subtitle v-text="'hi'" />
                        </v-list-item-content>
                        <v-list-item-icon>
                          <v-icon :color="item.active ? 'primary' : 'light-blue accent-3'">
                            mdi-chat
                          </v-icon>
                        </v-list-item-icon>
                      </v-list-item>
                      <v-divider :key="`chatDivider${index}`" class="my-0" />
                    </template>
                  </v-list-item-group>
                </v-list>
              </v-responsive>
            </v-col>
            <v-col cols="auto" class="flex-grow-1 flex-shrink-0">
              <v-responsive v-if="activeChat" class="overflow-y-hidden fill-height" height="500">
                <v-card flat class="d-flex flex-column fill-height">
                  <v-card-title>
                    Mamang Kesbor
                  </v-card-title>
                  <v-card-text class="flex-grow-1 overflow-y-auto">
                    <div v-for="(msg, i) in messages" :key="i">
                      <div :class="{ 'd-flex flex-row-reverse': msg.me }">
                        <template>
                          <v-chip
                            :color="msg.me ? 'primary' : 'light-blue accent-3'"
                            dark
                            style="height:auto;white-space: normal;"
                            class="pa-4 mb-2"
                            v-on="on"
                          >
                            {{ msg.content }}
                            <sub class="ml-2" style="font-size: 0.5rem;">{{ msg.created_at }}</sub>
                            <v-icon v-if="hover" small>
                              expand_more
                            </v-icon>
                          </v-chip>
                        </template>
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-text class="flex-shrink-1">
                    <v-text-field
                      v-model="messageForm.content"
                      label="Type a message"
                      type="text"
                      no-details
                      outlined
                      append-outer-icon="mdi-send"
                      @keyup.enter="send"
                      @click:append-outer="send"
                      hide-details
                    />
                  </v-card-text>
                </v-card>
              </v-responsive>
            </v-col>
          </v-row>
        </v-container> -->
    </v-app>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';
import apexchart from 'vue-apexcharts';
// import VueQrcode from 'vue-qrcode';

import { io } from 'socket.io-client';

const URL = process.env.VUE_APP_SOCKET_CHAT_URL;
const socket = io(URL, { autoConnect: false });

socket.onAny((event, ...args) => {
  console.log(event, args);
});

export default {
  name: 'App',
  components: {
    apexchart
    // VueQrcode
  },
  computed: {
    noNodesSelected() {
      return this.selectedNodeIds.length === 0;
    },
    someNodesSelected() {
      return this.selectedNodeIds.length > 0 && !this.allNodesSelected;
    },
    allNodesSelected() {
      return this.selectedNodeIds.length === this.graphWithNodes.nodes.length;
    }
  },
  data: () => ({
    series: [
      {
        name: 'Score',
        data: [28, 29, 33]
      },
      {
        name: 'Rank',
        data: [3, 3, 3]
      }
    ],
    chartOptions: {
      chart: {
        height: 350,
        type: 'line',
        dropShadow: {
          enabled: true,
          color: '#000',
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2
        },
        toolbar: {
          show: false
        }
      },
      colors: ['#1A73E8', 'transparent'],
      dataLabels: {
        enabled: true
      },
      tooltip: {
        enabled: true,
        enabledOnSeries: undefined,
        shared: true,
        followCursor: false,
        intersect: false,
        inverseOrder: false,
        style: {
          fontSize: '12px'
        },
        custom: function({ series, dataPointIndex }) {
          return (
            '<div class="arrow_box pa-2">' +
            '<span>' +
            'Bahasa Indonesia' +
            '</span></br>' +
            '<v-divider class="mt-2 mb-2">' +
            '<span>' +
            'Score : ' +
            '<span style="font-weight: bold;">' +
            series[0][dataPointIndex] +
            '</span>' +
            '</span>' +
            '</br>' +
            '<span>' +
            'Rank : ' +
            '<span style="font-weight: bold;">' +
            series[1][dataPointIndex] +
            '</span>' +
            '</span>' +
            '</div>'
          );
        }
      },
      stroke: {
        curve: 'smooth'
      },
      title: {
        text: 'Average Score',
        align: 'left'
      },
      grid: {
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5
        }
      },
      markers: {
        size: 1
      },
      xaxis: {
        categories: ['Matematika', 'Bahasa Indonesia', 'English'],
        tooltip: {
          enabled: false
        }
      },
      yaxis: {
        title: {
          text: 'Score'
        }
      },
      legend: {
        show: false
      }
    },
    radioGroup: '',
    assignmentCount: 7,
    datasCourse: [
      {
        courseId: 14,
        courseName: 'Matematika',
        assignmentCount: 5,
        assignments: [
          {
            number: 1,
            score: 76.666664
          },
          {
            number: 2,
            score: 80.0
          },
          {
            number: 3,
            score: 100.0
          },
          {
            number: 4,
            score: 50.0
          },
          {
            number: 5,
            score: 78.666664
          }
        ]
      },
      {
        courseId: 15,
        courseName: 'IPA',
        assignmentCount: 7,
        assignments: [
          {
            number: 1,
            score: 76.666664
          },
          {
            number: 2,
            score: 80.0
          },
          {
            number: 3,
            score: 100.0
          },
          {
            number: 4,
            score: 50.0
          },
          {
            number: 5,
            score: 78.666664
          },
          {
            number: 6,
            score: 70.0
          },
          {
            number: 7,
            score: 80.0
          }
        ]
      },
      {
        courseId: 17,
        courseName: 'IPS',
        assignmentCount: 2,
        assignments: [
          {
            number: 1,
            score: 76.666664
          },
          {
            number: 2,
            score: 80.0
          }
        ]
      }
    ],
    model: 'Edit Your Content Here!',
    activeChat: 1,
    dialog: false,
    messageContent: { type: 'TEXT', content: '' },
    messageByUser: [],
    messageList: [],
    to: { id: 2, name: 'Maria', profileImg: 'https://picsum.photos/id/10/200/300' },
    contactArr: [],
    selectedNodeIds: [],
    active_tab: 2,
    tabs: [
      { id: 0, name: 'tab1' },
      { id: 1, name: 'tab2' },
      { id: 2, name: 'tab3' }
    ],
    graphWithNodes: {
      id: 1,
      name: 'The graph',
      nodes: [
        {
          id: 1,
          graphId: 1
        },
        {
          id: 2,
          graphId: 1
        }
      ]
    },
    icons: ['mdi-rewind', 'mdi-play', 'mdi-fast-forward'],
    eraporGroups: [
      {
        eraporGroupId: 22,
        name: 'Group Test',
        courses: [
          {
            eraporTemplateCourseId: 30,
            courseName: 'Template Course Test',
            minimumCriteria: 75,
            value: 0,
            predicate: 'B',
            description: '<p>Goodd</p>'
          },
          {
            eraporTemplateCourseId: 31,
            courseName: 'New Template Course',
            minimumCriteria: 75,
            value: 0,
            predicate: 'B',
            description: '<p>das</p>'
          }
        ]
      },
      {
        eraporGroupId: 22,
        name: 'Group Test',
        courses: [
          {
            eraporTemplateCourseId: 30,
            courseName: 'Template Course Test',
            minimumCriteria: 75,
            value: 0,
            predicate: 'B',
            description: '<p>Goodd</p>'
          },
          {
            eraporTemplateCourseId: 31,
            courseName: 'New Template Course',
            minimumCriteria: 75,
            value: 0,
            predicate: 'B',
            description: '<p>das</p>'
          }
        ]
      }
    ]
  }),
  methods: {
    exportToPDF() {
      var opt = {
        margin: 1, //top, left, buttom, right
        filename: 'document.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { dpi: 192, scale: 2, letterRendering: true },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
        pageBreak: { mode: 'css', after: '.break-page' }
      };

      html2pdf()
        .set(opt)
        .from(this.$refs.document)
        .toPdf()
        .get('pdf')
        .then(function(doc) {
          console.info(doc.output('blob'));
        })
        .save();
    },
    download() {
      html2canvas(document.querySelector('#app'), { imageTimeout: 5000, useCORS: true }).then(canvas => {
        // document.getElementById('pdf').appendChild(canvas);
        let img = canvas.toDataURL('image/png');
        let pdf = new jsPDF('portrait', 'mm', 'a4');
        pdf.addImage(img, 'JPEG', 5, 5, 400, 287);
        pdf.save('relatorio-remoto.pdf');
      });
    },
    deleteNodes() {
      for (const nodeId of this.selectedNodeIds) {
        this.deleteNode(nodeId);
      }
      this.selectedQueueIds = [];
    },
    deleteNode(id) {
      this.graphWithNodes.nodes = this.graphWithNodes.nodes.filter(node => node.id !== id);
    },
    toggleCompleteSelection() {
      if (this.noNodesSelected || this.someNodesSelected) {
        this.selectedNodeIds = this.graphWithNodes.nodes.map(node => node.id);
      } else {
        this.selectedNodeIds = [];
      }
    },
    incomingMessage() {
      socket.emit('SEND_PRIVATE_MESSAGE', this.messageContent, [this.to]);
      this.messageContent.content = null;
      this.scrollToEnd();
    },
    changeAccount(item) {
      console.info(item.userId);
    },
    scrollToEnd: function() {
      var container = this.$el.querySelector('#container');
      container.scrollTop = container.scrollHeight;
    },
    listContact() {
      this.axios.get('http://13.212.32.6:3001/contact').then(response => {
        this.contactArr = response.data.data;
        // console.info(response.data.data);
      });
    }
  },
  created() {
    this.listContact();
    const token = 'ask_your_tech_lead';
    socket.auth = { token, userId: 1, username: 'Agung' };
    socket.connect();

    socket.emit('FETCH_MESSAGE', this.to);
    socket.on('MESSAGE_SENT', messageList => {
      this.messageList = messageList;
    });

    socket.emit('FETCH_USER_CONVERSATION');
    socket.on('USER_CONVERSATION_SENT', messageByUser => {
      this.messageByUser = messageByUser;
    });

    socket.on('PRIVATE_MESSAGE_SENT', message => {
      this.messageList.push({ ...message, isFromSelf: message.sender === 1 });
    });

    socket.on('connect_error', err => {
      console.log(err);
    });
    this.scrollToEnd();
  }
};
</script>

<style lang="scss" scoped>
html,
body {
  height: 100%;
}

body {
  height: 100%;
}

.v-card {
  transition: opacity 0.4s ease-in-out;
}

.v-card:not(.on-hover) {
  opacity: 0.6;
}

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}

th,
td {
  padding: 10px;
}

.header-table {
  background-color: #00BF63;
  border-radius: 8px;
  height: 63px;
}

.header-table-text {
  color: #ffffff;
  font-family: Montserrat;
  font-size: 13px;
}
.header-group {
  background-color: #eef6fc;
  border-radius: 8px;
  height: 63px;
}
.header-group-text {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 10px;
}
.header-group td {
  border-radius: 10px;
}

.theme--light.v-divider {
  border-color: #ffffff !important;
}
tbody:before {
  content: '@';
  display: block;
  line-height: 10px;
  text-indent: -99999px;
}

.attendance-scroller {
  overflow-x: scroll;
  overflow-y: visible;
}
.attendance-table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;

  th {
    padding: 10px;
    text-align: left;
    color: #fff;
  }

  td {
    padding: 0px 13px;
    height: 50px;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    background: #fff;

    &:not(.attendance-sticky) {
      font-weight: bold;

      &:hover {
        background: #f8f8f8;
      }
    }
  }

  thead {
    tr {
      th {
        $height: 100px;
        height: $height;
        background: #00BF63;

        div {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;

          button {
            position: absolute;
            top: -5px;
            right: 0;
          }
        }
      }
    }
  }
}
.break-page {
  break-after: page;
}
.content {
  padding: 30px;
}
</style>
